import { E_NAV_KEY, E_ROUTER_NAME, E_ROUTER_PARAMS } from '@pharmsnap/pharmsnap-web/types/enum'
import { createWebTitle } from '@pharmsnap/pharmsnap-web/utils/business/document-title'
import type { RouteConfig } from 'vue-router'

const meta = {
  activeKey: E_NAV_KEY.HOMEPAGE,
  hideQuickSearch: true,
  notWide: true,
}

export default {
  path: '/ai',
  component: () => import('@pharmsnap/pharmsnap-web/views/layout/LsChatLayout'),
  meta,
  children: [
    {
      path: '/ai',
      name: E_ROUTER_NAME.LS_CHAT_HOME,
      component: () => import('@pharmsnap/pharmsnap-web/views/chat/LSChatHome'),
      meta: {
        ...meta,
        title: createWebTitle('芽仔', 'Hiro LS Researcher'),
      },
    },
    {
      path: `share/:${E_ROUTER_PARAMS.CHAT_SHARE_ID}`,
      name: E_ROUTER_NAME.LS_CHAT_SHARE,
      props: (route) => ({
        id: route.params[E_ROUTER_PARAMS.CHAT_SHARE_ID],
      }),
      component: () => import('@pharmsnap/pharmsnap-web/views/chat/ChatShare'),
      meta: {
        ...meta,
        title: createWebTitle('分享对话', 'Share Chat'),
      },
    },
    {
      path: `:${E_ROUTER_PARAMS.CHAT_ID}`,
      name: E_ROUTER_NAME.LS_CHAT,
      props: (route) => ({
        id: route.params[E_ROUTER_PARAMS.CHAT_ID],
      }),
      component: () => import('@pharmsnap/pharmsnap-web/views/chat/ChatDetail'),
      meta: {
        ...meta,
        title: createWebTitle('芽仔', 'Hiro LS Researcher'),
      },
    },
  ],
} as RouteConfig
